window.$ = window.jQuery = require('jquery');

require('popper.js/dist/popper.min');
window.bootstrap = require('bootstrap/dist/js/bootstrap.min');

window.VGNav = require('vgnav/dist/js/vgnav');
window.AOS = require('aos/dist/aos');
window.fancybox = require('@fancyapps/ui/dist/fancybox.esm');
window.Cookies = require('js-cookie');

require('vgformsender/dist/js/vgformsender.min');
require('vgscrollto/assets/js/jquery.vegasScrollTo');
require('vgsidebar/dist/js/vgsidebar');
require('inputmask/dist/inputmask');
require('jquery-nice-select');
require('select2/dist/js/select2');
require('ion-rangeslider/js/ion.rangeSlider');
require('jquery-toast-plugin/dist/jquery.toast.min');

require('../../vendor/dropdown/jquery.vegasDropdown');
require('../../vendor/cnt-el/jquery.vegasCountElements');
require('../../vendor/modules/bg');
require('../../vendor/modules/resposive-content');
require('../../vendor/modules/carousel');
require('../../vendor/modules/modal');
require('../../vendor/modules/mask');
require('../../vendor/modules/map');

require('./modules/catalog/catalog');
require('./modules/auth/auth');
require('./modules/account/account');
require('./modules/contests');
require('./modules/vegas');
require('./modules/location');
require('./modules/location-city');
require('./modules/search');
require('./modules/form-loader');
require('./modules/date-countdown');
require('./modules/ym');
require('./modules/yandex_captcha');

require('./functions');

// [[vegas]]
require('./custom');
